import React, { useEffect, useState } from 'react';
import { partnerSections as partnerSectionsMock } from '../data/mock';
import { api } from '../api/client';

export default function SponsorsSection() {
  const [sections, setSections] = useState(partnerSectionsMock);
  useEffect(() => {
    let alive = true;
    api.getPartners().then((rows) => {
      if (alive && Array.isArray(rows) && rows.length > 0) setSections(rows);
    }).catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!sections || sections.length === 0) return null;

  return (
    <section className="py-16 bg-navy">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        {sections.map((section) => <SectionBlock key={section.id} section={section} />)}
        <p className="text-center text-white/50 text-xs mt-6">
          Vuoi diventare partner?{' '}
          <a href="mailto:memorialeugenioabbro@gmail.com" className="text-pink-brand hover:underline">
            memorialeugenioabbro@gmail.com
          </a>
        </p>
      </div>
    </section>
  );
}

function SectionBlock({ section }) {
  const items = section.items || [];
  return (
    <div className="mb-10">
      <div className="text-center mb-6">
        <h2 className="section-title centered text-3xl md:text-4xl">{section.titolo}</h2>
        {section.sottotitolo && <p className="text-white/70 mt-3 text-sm">{section.sottotitolo}</p>}
      </div>
      {section.modalita === 'image' && section.immagine ? (
        <div className="bg-white rounded-2xl p-6 lg:p-8">
          <img src={section.immagine} alt={section.titolo} className="w-full h-auto max-h-[520px] object-contain mx-auto" />
        </div>
      ) : items.length === 0 ? (
        <div className="bg-white/5 border border-white/10 rounded-2xl p-6 text-center text-white/50 text-sm">Nessun partner.</div>
      ) : (
        <div className="bg-white rounded-2xl p-5 lg:p-7">
          <div className={`grid gap-4 items-center ${section.id === 'main' ? 'grid-cols-1 sm:grid-cols-3' : 'grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5'}`}>
            {items.map((s) => <LogoCard key={s.id} sponsor={s} large={section.id === 'main'} />)}
          </div>
        </div>
      )}
    </div>
  );
}

function LogoCard({ sponsor, large = false }) {
  if (sponsor.logo) {
    return (
      <div className="flex flex-col items-center justify-center text-center p-3">
        <img src={sponsor.logo} alt={sponsor.name} className={`${large ? 'h-20' : 'h-14'} w-auto object-contain mb-2`} />
        <div className="text-navy-dark font-bold text-xs leading-tight">{sponsor.name}</div>
        <div className="text-gray-500 text-[10px] mt-0.5">{sponsor.tagline}</div>
      </div>
    );
  }
  return (
    <div className="group flex flex-col items-center justify-center text-center p-3 rounded-xl hover:bg-gray-50 transition-colors min-h-[110px]">
      <div className={`${large ? 'w-20 h-20 text-xl rounded-2xl' : 'w-12 h-12 text-sm rounded-full'} flex items-center justify-center text-white font-bold mb-2 group-hover:scale-110 transition-transform shadow-md`} style={{ backgroundColor: sponsor.color }}>
        {sponsor.name.substring(0, 2).toUpperCase()}
      </div>
      <div className="text-navy-dark font-bold text-xs leading-tight">{sponsor.name}</div>
      <div className="text-gray-500 text-[10px] mt-0.5">{sponsor.tagline}</div>
    </div>
  );
}
